import { render, staticRenderFns } from "./SeleccionarAbonoDiaAbonadoSga.vue?vue&type=template&id=23401092&scoped=true"
import script from "./SeleccionarAbonoDiaAbonadoSga.vue?vue&type=script&setup=true&lang=js"
export * from "./SeleccionarAbonoDiaAbonadoSga.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SeleccionarAbonoDiaAbonadoSga.vue?vue&type=style&index=0&id=23401092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23401092",
  null
  
)

export default component.exports